import React, { useState, useEffect, useRef } from 'react';
import WizardSteps from './components/WizardSteps';
import Step1 from './components/Step1';
import Step2 from './components/Step2Upd';
import Step3 from './components/Step3';
import Step4 from './components/Step4Upd';
import Step5 from './components/Step5';
import Step6 from './components/Step6Upd';
import { validateStep } from './validation';
import { postAnketa, updateAnketa, deleteFile, uploadFiles } from './activity';
import { prepData, prepUpdateData, deepClone } from './helpers';
import { cleanupStep, cleanupAllSteps } from './components/cleanup';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

const Wizard = ({isEdit=false,  isReadOnly=false, isAccept=false, data={}, onFinish, dictionary={}, step, setPersData, setPersStep, isPrivelegedUser=false }) => {

  const [legalStep, setLegalStep] = useState(1);
  const [currentStep, setCurrentStep] = useState( step );
  const [formData, setFormData] = useState(data);
  const [originalData, setOriginalData] = useState(deepClone(data));
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const wizardRef = useRef(null);


 
  useEffect(() => {
    if (wizardRef.current) {
      const top = wizardRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, [currentStep]);

  useEffect(()=>{
    setPersData(formData); 
  }, [formData]);
  useEffect(()=>{setPersStep(currentStep)}, [currentStep]);
  useEffect(()=>{
    setCurrentStep(1);
    const clonedData = deepClone(data);
    setLegalStep(0);
    setFormData(data);
    setOriginalData(clonedData);
    setErrors({});
  },[isEdit]);

  const handleChange = (field, value) => {
    const fields = field.split('.');
    setFormData(prev => {
      const newData = { ...prev };
      let current = newData;
      
      for (let i = 0; i < fields.length - 1; i++) {
        current = current[fields[i]];
      }
      
      current[fields[fields.length - 1]] = value;
      return newData;
    });
  };

const handleUpdateApplication = async (cleanedData) => {
  setIsSubmitting(true);
  try {
    const { outObj, files, filesToDelete } = prepUpdateData(cleanedData, originalData);
    
    await updateAnketa(data._id, outObj);
    
    if (filesToDelete && filesToDelete.length > 0) {
      
      for (const fileToDelete of filesToDelete) {
        try {
          await deleteFile(data._id, fileToDelete.fileId, fileToDelete.section);
        } catch (deleteError) {
          console.error(`Failed to delete file ${fileToDelete.fileId}:`, deleteError);
        }
      }
    } else {
      console.log('No files to delete');
    }
    
    // Загружаем новые файлы
    if (files && (
      files.cert.length > 0 || 
      files.benefits.length > 0 || 
      files.dissabilities.length > 0
    )) {
      await uploadFiles(data._id, files);
    } else {
      console.log('No new files to upload');
    }
    
    alert('Заявку успішно відредаговано!');
    onFinish();
  } catch (error) {
    console.error('Помилка при оновленні заявки:', error);
    alert('Сталася помилка при оновленні заявки');
  } finally {
    setIsSubmitting(false);
  }
};

  const nextStep = async () => {
    if (isSubmitting) return;
    if(isAccept) return cancelApplication();

    const cleanedData = cleanupStep(currentStep, formData);

    setFormData(cleanedData);
    
    const stepErrors = await validateStep(currentStep, cleanedData, isEdit);


    setErrors(stepErrors);

    if (Object.keys(stepErrors).length === 0) {
      if(legalStep < currentStep) setLegalStep(currentStep);
      if (currentStep < 6) {
        setCurrentStep(currentStep + 1);
      } else {
        if(isEdit) {
          // Режим редактирования - обновляем заявку
          await handleUpdateApplication(cleanedData);
          return;
        }

        // Перед отправкой очищаем все данные
        const fullyCleanedData = cleanupAllSteps(cleanedData);
        const { outObj, files } = prepData(fullyCleanedData);
        const result = await postAnketa(outObj, files);

        alert('Заявку успішно подано!');
        onFinish();
      }
    }
  };

  const prevStep = () => {
    // Очищаем данные текущего шага при переходе назад
    const cleanedData = cleanupStep(currentStep, formData);
    setFormData(cleanedData);
    
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const jumpStep = async (step) => {
    // Очищаем данные текущего шага перед переходом
    const cleanedData = cleanupStep(currentStep, formData);
    setFormData(cleanedData);
    
    if(step < currentStep) return setCurrentStep(step);

    for(let step_ = currentStep; step_ < step ; step_++ ){
        const stepErrors = await validateStep(step_, cleanedData, isEdit);

        if(Object.keys(stepErrors).length === 0) continue;

        setErrors(stepErrors);
        if(step_ !== currentStep) return setCurrentStep(step_ - 1);

        return;
    }

    setErrors({});
    return setCurrentStep(step);
  }

  const cancelApplication = () => {
    if (isAccept || window.confirm(isEdit ? "Вийти з режиму редагування?" : 'Ви впевнені, що хочете скасувати заявку?')) {
      setFormData({
        // ... исходные данные формы
      });
      setCurrentStep(1);
      setErrors({});
      if(!isEdit) alert('Заявку скасовано');
      onFinish();
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1 formData={formData} errors={errors} onChange={handleChange} isReadOnly={isReadOnly} isAccept={isAccept}/>;
      case 2:
        return <Step2 formData={formData} errors={errors} onChange={handleChange} isReadOnly={isReadOnly} />;
      case 3:
        return <Step3 formData={formData} errors={errors} onChange={handleChange} isReadOnly={isReadOnly} />;
      case 4:
        return <Step4 formData={formData} errors={errors} onChange={handleChange} isReadOnly={isReadOnly} />;
      case 5:
        return <Step5 formData={formData} errors={errors} onChange={handleChange} isReadOnly={isReadOnly} />;
      case 6:
        return <Step6 formData={formData} errors={errors} onChange={handleChange} isPrivelegedUser={isPrivelegedUser}  isReadOnly={isReadOnly} />;
      default:
        return <Step1 formData={formData} errors={errors} onChange={handleChange} isReadOnly={isReadOnly} />;
    }
  };



  return (
    <div className="main-content-wizard"  ref={wizardRef}>
      <h1 className="page-title-wiz">{isAccept ? "Перегляд заявки" : isEdit? "Редагування заявки" :"Створення нової заявки"}</h1>
      
      <WizardSteps currentStep={currentStep} onChange={jumpStep} legalSteps={legalStep}/>
      
      {renderStep()}
      
      <div className="wizard-actions">
        <div className="actions-left">
          {currentStep > 1 && (
            <button className="btn btn-secondary" onClick={prevStep}>
              Назад
            </button>
          )}
          <button 
            className="btn btn-next" 
            onClick={nextStep}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Обробка...' : 
             currentStep === 6 && !isAccept ? (isEdit ? 'Оновити заявку' : 'Подати заявку') : 'Далі'}
          </button>
        </div>
        <a href="#" className="link-cancel" onClick={cancelApplication}>
          {isAccept ? "Перейти до оформлення" :isEdit ? "Вийти з режиму редагування": "Скасувати заявку"}
        </a>
      </div>
    </div>
  );
};

export default Wizard;